import React from "react";

import { getPercentOptions } from "../../utils/getPercentOptions";
import DensitySelect from "../DensitySelect";

export default function AudienceGenderDensity({
  selectedAudienceGenderDensity,
  onChangeAudienceGenderDensity,
  isDisabled,
}) {
  const options = getPercentOptions(70);
  return (
    <DensitySelect
      selectedDensity={selectedAudienceGenderDensity}
      options={options}
      onChange={onChangeAudienceGenderDensity}
      dataAttr="audience-gender-density"
      isDisabled={isDisabled}
    />
  );
}
